import React from 'react'

import './WebLoading.css'
import QbIcon from '../QbIcon/QbIcon';

const WebLoading = ({ text }) => (
  <div className="main-container main-container--flex-column">
    <div className="web-loading-container">
      <QbIcon large loading />
      <div style={STYLE.TEXT}>{text}</div>
    </div>
  </div>
)

export default WebLoading

const STYLE = {
  TEXT: {
    marginTop: '20px',
    fontSize: '20px',
    color: 'var(--white-color)'
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/WebLoading/WebLoading.js